/// <reference path="pages-main.js"/>
/// <reference path="pages.js"/>

function CreateSubTaskFromListActions(obj, el) {
  obj['tr'] = $(el).parents('#' + obj.id);
  CreateSubTaskFromContextMenu(obj);
}

function CreateSubTaskFromContextMenu(parent) {
  var newCard;
  var OnError = function (error) {
    newCard.close();
    ShowError(error, null, 400);
  };

  function DoIt(decryptedKey) {
    var newTaskID;
    var serviceName;
    var serviceParams;
    //Создаём подзадачу

    if (parent.kind == "task") {
      serviceName = 'Task.asmx';
      serviceParams = { TaskID: parent.id, EncryptionKey: decryptedKey };
    } else {
      serviceName = 'Job.asmx';
      serviceParams = { JobID: parent.id, EncryptionKey: decryptedKey };
    }

    CallService(serviceName + '/CreateSubTask', serviceParams,
      function (res) {
        if (!res.Success) OnError(res.Error);
        else {
          newTaskID = res.Result;
          if (!!newTaskID) {
            parent.id = newTaskID;
            parent.kind = "task";
            var params = "mode=edit";
            newCard.location = GetObjectCardUrl(parent, params);
            newCard.focus();
          }
        }
      },
      OnError);


    //if (!!newTaskID) {
    //  parent.id = newTaskID;
    //  parent.kind = "task";
    //  var params = "mode=edit";
    //  ShowObjectCard(parent, params);
    //}
  }

  var encoding = parent.tr.attr('encoding');
  var pleaseWait = new WA.URL('/PleaseWait.aspx');
  pleaseWait.setParam('message', L('PLEASE_WAIT_TASK'));

  if (encoding > 0) {
    // Не поддерживаем работу с зашифрованными объектами.
    (new WA.CMP.dialogs.MessageBox()).showWarning(L('ERR_ENCODED_OBJECT_ARE_NOT_SUPPORTED'));
    //if ($('body').hasClass('tablet') || $('body').hasClass('smartphone')) {
    //  (new WA.CMP.dialogs.MessageBox()).showError(L('ERR_ENCODED_OBJECT_ARE_NOT_SUPPORTED'));
    //  return;
    //}

    Core.agent.getPlugin('edmsplugin').done(function (plugin) {
      var pluginName = parent.tr.attr('encpluginname');
      switch (encoding) {
        case '1':
          newCard = pleaseWait.open(parent.kind + parent.id);
          if (parent.kind == 'task') {
            WebAccess.agent.edms.getTaskDecryptedKey(parent.id, encoding, pluginName, "", DoIt, OnError);
          } else {
            WebAccess.agent.edms.getJobDecryptedKey(parent.id, encoding, pluginName, "", DoIt, OnError);
          }
          break;
        case '2':
        case '3':
          RequestPasswordForDecryption('',
            function (password) {
              newCard = pleaseWait.open(parent.kind + parent.id);
              if (parent.kind == 'task') {
                WebAccess.agent.edms.getTaskDecryptedKey(parent.id, encoding, pluginName, password, DoIt, OnError);
              } else {
                WebAccess.agent.edms.getJobDecryptedKey(parent.id, encoding, pluginName, password, DoIt, OnError);
              }
            });
          break;
      }
    });
  } else {
    newCard = pleaseWait.open('sub' + parent.kind + parent.id);

    //IOS замораживает вкладки, которые висят в фоне, поэтому к сожалению фабрики и асинхронные запросы в нем отдыхают
    if (WA.ENV.os.name.toLowerCase() === 'ios') {
      var folderId = WA.CR.getID() || OutboxFolderID;
      var page = (parent.kind == 'task' ? 'Task' : 'Job');
      var pageUrl = (new WA.URL('/' + page + '.aspx'));
      if (parent.kind == 'task') {
        pageUrl.setParam('mode', 'newsubtask');
      } else {
        pageUrl.setParam('op', 'newsubtask');
      }
      pageUrl.setParam('id', parent.id).setParam('folder', folderId).openIn(newCard);
      return;
    }

    DoIt(null);
  }
}


// Показывает запрашиваемые параметры для ззу.
// id - id задачи или задания.
// type - "job" или "task".
function ShowAskableParams(id, type, block) {
  id = id || GetParamInURL('id');
  type = type || (/job\.aspx/i.test(location.pathname) ? 'job' : 'task');
  block = block || null;
  ShowModalWindow("askable_params", {
    title: L("CUSTOMWORK_ASKABLE_PARAMS"),
    ok: function () {
      $('#modal_window').data('success', function () {
        $('#modal_window').dialog('close');
        if (type == 'job')
          DoAction("op=doit");
        else
          DoAction("-op");
      });
      $('#modal_window form').submit();
      return false;
    },
    cancel: function () {
      if (type == 'task') {
        CallService("/Task.asmx/SetStandardRoute", { TaskID: id, StandardRouteID: 0 }, function () {
          $('#modal_window').dialog('close');
          DoAction("-op")
        });
      } else {
        UnbindBeforeUnload();
        DoAction("-op&-val");
      }
    },
    params: { WorkID: id, WorkType: type, WorkflowBlock: block },
    height: "auto",
    width: 700,
    afterOpen: function () {
      setTimeout(function () {
        //иначе форма не растягивается при ListRequisite
        $('#modal_window').css('height', 'auto');
        //вызов события после показа окна с запрашиваемыми параметрами
        WebAccess.Job.fire("AfterShow");

        var currentDialog = $(".ui-dialog");
        // при перетаскивании диалога слетает высота и кнопки ОК/Отмена также могут уходить за границы видимой области
        currentDialog.on("dragstop", function (event, ui) {
          currentDialog.css('height', 'auto');
        });
      }, 50);
    }
  });
  $('#modal_window').css('overflow', 'auto');
}

function ClearOpAfterError() {
  var id = GetParamInURL('id');
  CallService("/Task.asmx/SetStandardRoute", { TaskID: id, StandardRouteID: 0 }, function () {
    $('#modal_window').dialog('close');
    DoAction("-op")
  });
}

function ShowErrorOnAskableParams(text) {
  ShowMessage(text, L("CUSTOMWORK_ASKABLE_PARAMS"), ClearOpAfterError, null, null, null, true);
}

// Показывает окно выбора типового маршрута.
function ChangeStandartRoute() {
  var id = GetParamInURL('id');
  ShowModalWindow("standard_route", {
    title: L("STANDARD_ROUTE"),
    ok: function () {
      var wnd = $('#modal_window');
      var routeID = wnd.find('#hSelID_route').val();

      SetStandardRoute(id, routeID, function () {
        DoAction("op=ChangeRoute");
        wnd.dialog('close');
        return false;
      }, function (errMessage) {
        wnd.data('error')(errMessage);
      });
      return false;
    },
    params: { TaskID: id }
  });
}

function SetStandardRoute(TaskID, StandardRouteID, OnSuccess, OnError) {
  GetStandardRouteCodeByAnalit(StandardRouteID, function (data) {
    var standardRouteCode;
    var setStandardRouteCallback = function () {
      CallService("/Task.asmx/SetStandardRoute", { TaskID: TaskID, StandardRouteID: StandardRouteID }, function (res) {
        if (res.Success) {
          if (OnSuccess) {
            var r = OnSuccess();
            if (r === false) {
              return;
            }
          }
          if (res.Result) {
            ShowAskableParams(TaskID, 'task');
          } else {
            DoAction("op=ChangeRoute");
          }
          if (OnSuccess) OnSuccess();
        } else {
          if (OnError) {
            OnError(res.Error);
          };
        }
      });
    }

    // если запрос выполнился успешно и вернул только одну запись (если больше, то что-то явно не то - по одному ИД может быть только одна запись).
    // третье условие - что венрнулся только Код записи.
    if (data.Success && data.Result.length == 1 && data.Result[0].Requisites.length == 1) {
      standardRouteCode = $.trim(data.Result[0].Requisites[0].Value);
    }

    // Если для ТМа с кодом standardRouteCode есть означенные события, то выполним событие "До запроса параметров".
    if (typeof WebAccess.Events[standardRouteCode] != 'undefined') {
      WebAccess.Task.fireAll("Select", setStandardRouteCallback, standardRouteCode);
    } else {
      setStandardRouteCallback();
    }
  }, function () {
    ClearOpAfterError();
  });
}

function ShowWarningForTaskRouteException(msg) {
  var _showWarningFunc = function (callback) {
    ShowMessage(msg, L('WARNING'), null, L('OK'), 600, callback, false);
  };
  var _isModalShown = IsModalShown();

  HideTopSpinner('', 0, null, _isModalShown);
  setTimeout(function () {
    if (_isModalShown) {
      // Отключаем горячие главищи вообще, что бы Enter на кнопке ОК в окне ошибки сработал нормально. Для этого же и setTimeout
      key.setScope('');
      _showWarningFunc(function () {
        key.setScope('modalwindow');
      });
    } else {
      _showWarningFunc();
    }
  }, 100);
}

// Получает выбранные элементы (либо в диалоге, если он показан, либо в выборе из справочника).
function GetRouteSelectedItemsCount() {
  var inps = [$("#CardContrrolRoute"), $('#CardContrrolObservers')];
  var count = 0;
  for (var i = 0; i < inps.length; i++) {
    var inp = inps[i];
    var ms = inp.data('MultiSelectModalWindowInstance');
    if (ms && ms.isModalShown()) {
      count += ms.dataObject.selectedItems.length;
    } else if (inp.length > 0) {
      count += inp.data('ReferenceSelectInstance').getValues().length;
    }
  }
  return count;
}

// Событие после смены маршрута с множественным выбором.
function TaskRouteChanged(inp, data, UsersRefName, UserGroupsRefName, StandardRoutesRefName, RouteLastObjectsRefName, isInModal) {
  var selItem;
  var isNeedToAddLastObject = true;
  if (!data || data.length == 0)
    return;

  if (!$.isPlainObject(data[0])) {
    // Данные выбраны через стандартное выпадающее меню.
    var id = data[0];
    var idParts = id.split(':');
    var refCode = '';
    if (idParts.length == 2) {
      refCode = idParts[0];
      id = idParts[1];
    } else {
      refCode = UsersRefName;
    };
    selItem = { groupcode: refCode, id: id, name: data[2] };
  } else {
    // Данные выбраны через модальное окно.
    selItem = data[0];
    // После нажатии на кнопку ОК уже не добавляем в последние объекты, т.к. уже были добавлены при переносе в правую часть.
    isNeedToAddLastObject = !!isInModal;
  };

  // Сохраним элемент для замены, т.к. возможно мы его изменим ниже.
  var itemToReplace = { groupcode: selItem.groupcode, id: selItem.id, name: selItem.name };

  // Если это псевдосправочник "Последние объекты в маршруте", то получим настоящий справочник и ИД выбираемой записи.
  if (selItem.groupcode === RouteLastObjectsRefName) {
    var idParts = selItem.id.split("_");
    if (idParts.length == 2) {
      selItem.groupcode = idParts[0];
      selItem.id = idParts[1];
    };
  };

  // Функция TaskRouteChanged срабатывает при нажатии на кнопку "ОК" в модальном диалоге, в этом случае, добавлять последние объекты не нужно,
  // т.к. они уже были добавлены при переносе в правую часть.
  // Добавляем к последним объектам, только корректные объекты.
  if (isNeedToAddLastObject && selItem.id > 0) {
    WA.SRV.session.addLastUsedObject(selItem.groupcode, selItem.id, selItem.name);
  }

  switch (selItem.groupcode) {
    case UsersRefName:
      //Текущее кол-во элементов поля
      if (typeof MAX_ROUTE_PARTICIPANT_COUNT !== 'undefined' && MAX_ROUTE_PARTICIPANT_COUNT !== null) {
        var CurrentUsersCount = GetRouteSelectedItemsCount();
        if (CurrentUsersCount > MAX_ROUTE_PARTICIPANT_COUNT) {
          inp.ReplaceLastSelectedItem(itemToReplace.groupcode + ':' + itemToReplace.id, []);
          ShowWarningForTaskRouteException(L("TO_MANY_ITEMS"));
        } else {
          if (!IsModalShown()) {
            WA.CMP.NTF.InlineHint.hideAll();
          }
        };
      }

      //Если выбрали из RouteLastObjectsRefName, то заменяем на обычного пользователя.
      if (itemToReplace.groupcode === RouteLastObjectsRefName) {
        inp.ReplaceSelectedItem(itemToReplace.groupcode + ':' + itemToReplace.id, [[UsersRefName + ':' + selItem.id, selItem.name, selItem.name]]);
      }

      break;
    case UserGroupsRefName:
      ExpandUsersGroup(inp, selItem, UserGroupsRefName, UsersRefName, itemToReplace);
      break;
    case StandardRoutesRefName:
      UnbindBeforeUnload();
      inp.SetDisabled();
      $('#CardContrrolObservers').SetDisabled();
      SetStandardRoute(GetParamInURL('id'), selItem.id, null, function (msg) {
        // покажем сообщение об ошибке
        ErrorShow(msg, true);
        // и почистим ReferenceSelect.
        inp.Clear();
        inp.SetEnabled();
        $('#CardContrrolObservers').SetEnabled();
      });
      break;
  };
}

function ExpandUsersGroup(inp, item, UserGroupsRefName, UsersRefName, itemToReplace) {
  if (item.groupcode == UserGroupsRefName) {
    ShowTopSpinner(L("GROUP_EXPANDS"), false, true);

    var replaceGroup = function (NeedProcessSubGroups) {
      // Получим всех пользователей в группе.
      CallService("/UserList.asmx/GetUsersInGroup", { GroupID: item.id, NeedProcessSubGroups: NeedProcessSubGroups, RenderItems: false }, function (res) {
        if (res.Success) {
          var newValues = [];
          //Текущее кол-во элементов поля
          var CurrentUsersCount = GetRouteSelectedItemsCount() - 1; // -1 без вставленной группы

          if (MAX_ROUTE_PARTICIPANT_COUNT == null || (CurrentUsersCount + res.Result.length) <= MAX_ROUTE_PARTICIPANT_COUNT) {
            if (!IsModalShown()) {
              WA.CMP.NTF.InlineHint.hideAll();
            }

            $.each(res.Result, function () {
              newValues.push([UsersRefName + ':' + this.id, ('' + this.text).escapeHtml(), this.text]);
            });

            //Переинициализируем компоненту.
            inp.ReplaceSelectedItem(itemToReplace.groupcode + ':' + itemToReplace.id, newValues);

            if (newValues.length > 0) {
              HideTopSpinner(L("GROUP_EXPANDED"), 3000, null, true);
            } else {
              HideTopSpinner(L("EMPTY_GROUP_WASNT_EXPANDED"), 3000, null, true);
            }
          } else {
            inp.ReplaceSelectedItem(itemToReplace.groupcode + ':' + itemToReplace.id, []);
            ShowWarningForTaskRouteException(L("TO_MANY_ITEMS"));
          }
        } else {
          inp.ReplaceSelectedItem(itemToReplace.groupcode + ':' + itemToReplace.id, []);
          ShowWarningForTaskRouteException(res.Error);
        };
      });
    };

    CallService("/UserList.asmx/HasGroupUsersAndSubGroups", { GroupID: item.id }, function (res) {
      if (res.Success) {
        // Если ли в группе и пользователи, и группы одновременно?
        if (res.Result) {
          var isButtonClicked = false;
          // Выдаем предложение что будем добавлять - пользователй группы или пользователей всех её подгрупп.
          var yesBtn = function () {
            isButtonClicked = true;
            replaceGroup(true);
          };
          var sett = {
            text: format(L('DO_YOU_ALSO_WANT_TO_ADD_USERS_FROM_SUBGROUPS_OF_GROUP'), { 'groupName': item.name }),
            close: function () {
              if (!isButtonClicked) {
                replaceGroup(false);
              }
              HideTopSpinner('', 3000, null, true);
              key.setScope('modalwindow');
            }
          };
          setTimeout(function () {
            // Отключаем горячие главищи вообще, что бы Enter на кнопке ОК в окне ошибки сработал нормально. Для этого же и setTimeout
            key.setScope('');
            ConfirmDialogNew(sett, yesBtn, function () { });
          }, 100);
        } else {
          // Добавляем всех пользователей всех подгрупп.
          replaceGroup(true);
        };
      };
    });
  }
}

function InitTaskRouteModalWindowsOpts(inp, UsersRefName, UserGroupsRefName, StandardRoutesRefName, customPlaceHolder, RouteLastObjectsRefName) {
  return {
    excludeGroups: [StandardRoutesRefName, RouteLastObjectsRefName],
    treeMode: true,
    customPlaceholder: customPlaceHolder,
    events: {
      'OnAfterOpen': function () {
        var inpId = inp.attr('id');
        if (inpId == 'CardContrrolRoute') {
          BindHelpIcoClickOnModalWindow('RouteSetup');
        } else {
          BindHelpIcoClickOnModalWindow('ObserversSetup');
        };
      },
      'OnSelectedItem': function (eventName, item) {
        TaskRouteChanged(inp, [item], UsersRefName, UserGroupsRefName, StandardRoutesRefName, RouteLastObjectsRefName, true);
      }
    }
  };
}

function ShowRouteModalWindowAfterLoad() {
  $(function () {
    setTimeout(function () {
      $("#CardContrrolRoute").ShowMultiSelectModalWindow();
    }, 100);
  });
};

// Навешиват кнопку удаления последних объектов.
function BindRemoveLastObjectBtn(RouteLastObjectsRefName, jControl) {
  var touchDev = $.ipad || WA.ENV.isAndroid();

  jControl.on('OnRowsCreated', function (ev, refCode, rows) {
    if (refCode.toLowerCase() === RouteLastObjectsRefName.toLowerCase()) {
      $.each(rows, function () {
        var row = $(this);
        if (!row.hasClass('removeLastObjBtnInit')) {
          var rowIco = row.find('.rs_ico');
          // Пропускаем Избранных, их нельзя удалять.
          if (!rowIco.hasClass('FavoriteUser_16.png') && !rowIco.hasClass('FavoriteUserGroup_16.png')) {
            var delBtn = $('<p class="deleteLastObj sprite_ico ' + (touchDev ? '' : 'vishidden') + '">' +
              '<svg class="refselect-input__delete-icon"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#close-delete-16"></use></svg>' +
              '</p>');
            delBtn.on('click', function (ev) {
              ev.stopPropagation();
              ev.preventDefault();

              //Получаем набор данных; берем ИД [0]; для этого справочника ИД сложный, поэтому берем настоящий ИД [1]. Сложнный ИД в формате "КОДСПР_ИД"
              var id = row.attr('DataRow').split('|')[0].split('_')[1];
              WA.SRV.session.removeLastUsedObject(id);
              // Удаляем сразу, что бы не ждать завершения запроса и пользователь сразу увидел результат своего действия.
              row.remove();

              return false;
            });
            row.find('.rs_td').prepend(delBtn);

            // Показываем кнопку удаления при наведении только для обычных PC.
            if (!touchDev) {
              row.on('mouseenter.removeLastObj', function () {
                $(this).find('.deleteLastObj').removeClass('vishidden');
              }).on('mouseleave.removeLastObj', function () {
                $(this).find('.deleteLastObj').addClass('vishidden');
              });
            };
          };

          row.addClass('removeLastObjBtnInit');
        };
      });
    }
  });
}



(function (global) {

  /** Чтобы получение сертификатов было всего один раз на странице */
  var lastResponse = null;

  // Получаем сертификат по умолчанию.
  var getUserDefaultCertificate = function () {
    if (!!lastResponse) return lastResponse;
    return lastResponse = WA.SRV.call('/Certificates.asmx/GetDefaultOrFirstValid', null, null, null, true, true);
  };

  // Отправляет запрос к агенту для подписания.
  var signingCustomWorkIds = [];
  var _sendSignDataToAgent = function (type, id, pluginName, pluginVersion, certId, afterSignCallback, tokenPinCode) {
    if (type === 'T') {
      WebAccess.agent.edms.signTask(id, certId, pluginName, null, null, null, null, afterSignCallback, pluginVersion, tokenPinCode);
    }
    if (type === 'J') {
      WebAccess.agent.edms.signJob(id, certId, pluginName, null, null, null, null, afterSignCallback, pluginVersion, tokenPinCode);
    }
  };

  var getErrorWithCustomWorkName = function (error, name, type, id) {
    if (name) {
      return format('<li>{0} "<a href="{3}" target="_blank">{1}</a>": {2}</li>',
                    L((type === 'T' ? 'TASK' : 'JOB')),
                    name,
                    error,
                    (new WA.Link(id, L((type === 'T' ? OBJECT_TYPE.TASK : OBJECT_TYPE.JOB)))).toURL().asString());
    } else {
      return '<li>' + error + '</li>';
    }
  };

  var SignCustomWork = function (type, id, name, opt_silent) {
    var result = $.Deferred();

    if (name) {
      name = ('' + name).escapeHtml();
    }

    Core.agent.getPlugin('edmsplugin').done(function (plugin) {
      getUserDefaultCertificate().done(function (res, resp) {
        var certificate = res;
        var certArr = certificate.split('###');
        models.User._current.DefaultCertificate = {
          PluginName: certArr[0],
          CertificateID: certArr[1],
          PluginVersion: certArr[2],
          IsValid: !resp.Warning
        };

        var cert = models.User._current.DefaultCertificate;
        if (!cert.IsValid) {
          if (!opt_silent) ShowError((resp.Warning || '').fromISBuilderToNormal());
          result.reject(getErrorWithCustomWorkName((resp.Warning || '').fromISBuilderToNormal(), name, type, id));
          return;
        }

        // Подписание ЗЗУ.
        var onSignCallback = function(res) {
          if (res.success) {
            var successMessageCode = (type === 'T' ? 'TASK_SIGN_SUCCESS' : 'JOB_SIGN_SUCCESS');
            if (!opt_silent) ShowTopSpinnerResult(L(successMessageCode), 3000);
            result.resolve(L(successMessageCode));
          } else {
            if (!!res.message && (res.result === 'ERR_PIN_REQUIRED')) {

              var jTokenPinCode = $("#task_token_pin_code");
              // Так мы определим, что у нас происходит массовое совместное подписание документов и ЗЗУ
              var jDocsTokenPinCode = $("#modal_window").find(".token_pin_code");

              if (signingCustomWorkIds.indexOf(id) == -1)
                signingCustomWorkIds.push(id);

              if (jTokenPinCode.length == 0) {
                // Проверка массового совместном подписании документов и ЗЗУ
                if (jDocsTokenPinCode.length != 0)
                {
                  if (jDocsTokenPinCode.val() != "") {
                    for (var i = 0; i < signingCustomWorkIds.length; i++)
                      _sendSignDataToAgent(type, signingCustomWorkIds[i], cert.PluginName, cert.PluginVersion, cert.CertificateID, onSignCallback, jDocsTokenPinCode.val());
                  }

                  return;
                }
              
                var formBuilder = new WA.CMP.forms.FormBuilder('taskjobpincode');
                var tokenPinCodeId = 'TASK_TOKEN_PIN_CODE';
                formBuilder.addInput(tokenPinCodeId, null, null, 'password');

                var dialog = new WA.CMP.dialogs.BaseDialog();
                dialog.title = L("PIN_CODE_ASK");
                dialog.setHtml(formBuilder.render());

                dialog.isShowCancelButton = true;
                dialog.ok = function() {
                  var pinCodeValue = formBuilder.getValue(tokenPinCodeId);
                  dialog.close();
                  for (var i = 0; i < signingCustomWorkIds.length; i++)
                    _sendSignDataToAgent(type, signingCustomWorkIds[i], cert.PluginName, cert.PluginVersion, cert.CertificateID, onSignCallback, pinCodeValue);
                };
                dialog.show();
              }
              return;
            }

            if (!!res && !opt_silent) ShowError(res.message);
            result.reject(getErrorWithCustomWorkName(res.message.fromISBuilderToNormal(), name, type, id));
          }
        };
        _sendSignDataToAgent(type, id, cert.PluginName, cert.PluginVersion, cert.CertificateID, onSignCallback, null);

      }).fail(function (errMsg) {
        if (!opt_silent) ShowError(errMsg);
        result.reject(getErrorWithCustomWorkName(errMsg.fromISBuilderToNormal(), name, type, id));
      });
    }).fail(function () {
      var err = L("ERR_SIGNING_UNSUPPORTED");
      if (!opt_silent) ShowError(err);
      result.reject(getErrorWithCustomWorkName(err.fromISBuilderToNormal(), name, type, id));
    });
    return result;
  };

  global.SignTask = function (id, name, opt_silent) {
    return SignCustomWork('T', id, name, opt_silent);
  };
  global.SignJob = function (id, name, opt_silent) {
    return SignCustomWork('J', id, name, opt_silent);
  };


  var GetEncryptedCustomWorkTree = function (type, id, encodingType, pluginName) {
    Core.agent.getPlugin('edmsplugin').done(function (plugin) {
      //Получает ключ для расшифровки текста делового процесса
      var GetDecryptedKey = function (additionalParams) {
        ShowTopSpinner(L("PLEASE_WAIT"), true);

        //Запрашиваем токен на расшифровку текста делового процесса
        RequestToken(TOKEN_OPERATION.GET_ENCRYPTION_KEY, function (token) {
          var requestName = (type == 'T' ? "GetTaskDecryptedKey" : "GetJobDecryptedKey");

          //Заполняем параметры запроса
          var params = { "EncodeType": encodingType, "EncryptionPluginName": pluginName, "Token": token };
          if (!!additionalParams) $.extend(params, additionalParams);
          if (type == 'T') {
            params["TaskID"] = id;
          } else {
            params["JobID"] = id;
          }

          WebAccess.agent.transmitRequest(requestName, "edmsplugin", params).done(function (response) {
            //Получаем текст делового процесса
            if (type == 'T') {
              CallService("Task.asmx/GetWorkTreeHtml", { TaskID: id, EncryptionKey: response.result }, function (response) {
                if (response.Success) {
                  if ($('.ListRequisiteList[kind=att]').length > 0) {
                    $('span.MainText').append(response.Result);
                  } else {
                    window.location.reload();
                  }
                } else {
                  $('span.MainText').append(response.Error);
                }
              });
            } else {
              CallService("Job.asmx/GetWorkTreeHtml", { JobID: id, EncryptionKey: response.result }, function (response) {
                if (response.Success) {
                  if ($('.ListRequisiteList[kind=att]').length > 0) {
                    $('span.MainText').append(response.Result);
                  } else {
                    window.location.reload();
                  }
                } else {
                  $('span.MainText').append(response.Error);
                }
              });
            }
          }).fail(function (response) {
            try {
              //FIXME: нужен ли декодинг?
              //resultMessage = decodeURIComponent(response.message);
              resultMessage = response.message;
            } catch (e) {
              resultMessage = L('CUSTOMWORK_DECODING_FAIL');
            }
            ShowError(resultMessage, function () {
              if (encodingType % 2 === 1) {
                CloseWindow();
              } else {
                GetEncryptedCustomWorkTree(type, id, encodingType, pluginName);
              }
            },
            400,
            function () {
              CloseWindow();
            });
          }).always(function (response) {
            HideTopSpinner("", 1);
          });
        }, id);
      };

      //Если в шифровании используется пароль, то запросим его у пользователя.
      if (encodingType >= 2) {
        return RequestPasswordForDecryption(null,
          function (pass) { GetDecryptedKey({ Password: pass }); },
          function () {
            if (!!!$("#docPassword").data('entered')) {
              CloseWindow();
            }
          }).cancel = function () {
            CloseWindow();
          };
      } else {
        GetDecryptedKey(null);
      }
    });
  };

  global.GetEncryptedTaskTree = function (id, encoding, pluginName) {
    return GetEncryptedCustomWorkTree('T', id, !!encoding ? encoding : WebAccess.current.Encoding, !!pluginName ? pluginName : WebAccess.current.PluginName);
  };

  global.GetEncryptedJobTree = function (id, encoding, pluginName) {
    return GetEncryptedCustomWorkTree('J', id, !!encoding ? encoding : WebAccess.current.Encoding, !!pluginName ? pluginName : WebAccess.current.PluginName);
  };

})(window);


var setSavedTextWidth = function (jMainContainer) {
  //var setWidth = function () {
  //  // Если в тексте написано большое неразрывное слово, что для того что бы оно не раздвигало все остальное, устанавливаем размер явно
  //  jMainContainer.find(".card_task_savedtext_container").css({
  //    "width": jMainContainer.find(".card:first").width() - 30 // 30 - это padding + border + margin.
  //  });
  //};
  //setWidth();
  //setTimeout(function () { //для корректировки после появления и исчезания скрола.
  //  setWidth();
  //}, 10);
};

function ShowEncodedObjectError(error) {
  var mbox = new WA.CMP.dialogs.MessageBox();
  mbox.width = 470;
  mbox.showError(error, null, null, function () { WA.CR.window.close(); });
}

var clamp = function (val, min, max) {
  return Math.min(Math.max(val, min), max);
};

// Инициализирует возможность изменять размер панели вложений.
function InitAttachmentsResize() {
  var minX = 850;
  var defaultAttachWidth = 260;

  function setWidth(w) {
    w = parseInt(w, 10);
    var jMainContainer = $('#main_container');
    var attd = jMainContainer.find('.attachments_td');
    attd.width(w);

    var jCard = jMainContainer.find(".card:first");
    jCard.css({ "marginRight": w });
    var jLeftColumn = $('#left_column');
    if (jLeftColumn.hasClass('horizontal')) {
      jLeftColumn.css({ "marginRight": w});
    }

    setSavedTextWidth(jMainContainer);

    var lr = ListRequisite(attd.find('.ListRequisite').attr('id'));
    if (lr.onUpdate) lr.onUpdate();
  }

  var res = $.cookie('attwidth');
  if (!!res) {
    setWidth(res);
  } else {
    setWidth(defaultAttachWidth);
  }

  $('#attachments_dragarea').mousedown(function (ev) {
    ev.preventDefault();
    var $this = $(this);
    var maxX = $(window).width() - defaultAttachWidth;
    $this.addClass('dragging').offset({ left: clamp(ev.pageX, minX, maxX) });
    $('html').css('cursor', 'col-resize')
    .bind('mousemove.attresize', function (ev) {
      ev.preventDefault();
      $this.offset({ left: clamp(ev.pageX, minX, maxX) });
    })
    .bind('mouseup.attresize', function (ev) {
      ev.preventDefault();
      $('html').css('cursor', '').unbind('mousemove.attresize').unbind('mouseup.attresize');
      $this.removeClass('dragging').css('left', '');
      var w = $(window).width() - clamp(ev.pageX, minX, maxX) + 10;
      setWidth(w);
      document.cookie = "attwidth=" + w;
    });
  });
}


// Для ресайза текста ззу.
$(function () {
  var initialSavedTextSize = $(".bottom_textarea:visible").innerHeight();

  //Нам ни к чему шевелиться на страницах, где это не требутся.
  var allowedPages = ['task', 'job', 'notice'];
  if (allowedPages.indexOf(WA.getLocation()) === -1) return;

  var jMainContainer = $('#main_container');
  var jSavedText = jMainContainer.find('.card_task_savedtext_container');
  if (jSavedText.length) {
    var savedTextInitTop = jSavedText.offset().top;
    var jTextarea = jMainContainer.find('.bottom_textarea');

    var isResize = false;

    window.initSavedTextHeight = function (ev) {
      if (!isResize) {
        var isSmall = windowHeight() < MIN_WINDOW_HEIGHT;
        wh = isSmall ? $(document).height() : windowHeight();
        jTextarea.height(Math.max(100, jTextarea.height()));
        // Значение 12px - дополнительное смещение карточки ЗЗУ отностительно страницы.
        var h = Math.max(100, wh - savedTextInitTop - jTextarea.height() - 12);
        jSavedText.height(h);
        if (!$.ipad) {
          jSavedText.resizable("option", "maxHeight", jSavedText.height() + jTextarea.height() - initialSavedTextSize);
        }
        setRealHeightAndWidth();

        savedTextInitTop = jSavedText.offset().top; //пересчитываем после изменения размеров.
      }
    };

    if (!$.ipad) {
      var dragEl = jSavedText.next();
      jSavedText.resizable({
        handles: { s: dragEl },
        helper: "ui-resizable-helper",
        start: function () { isResize = true; },
        resize: function (ev, ui) {
          ui.helper.width(ui.originalSize.width - 1);
        },
        stop: function () {
          //debugger;
          var wh = windowHeight();
          if (wh < 626) wh = 626;
          var h = Math.max(100, wh - savedTextInitTop - jSavedText.height() - 23);
          jTextarea.height(h);
          jSavedText.css({ "width": "auto" });
          //Что бы не улетало при ресайзе.
          setSavedTextWidth(jMainContainer);
          isResize = false;
        },
        minHeight: 100,
        maxHeight: jSavedText.height() + jTextarea.height() - 100
      });
    }

    initSavedTextHeight();

    setTimeout(function() {
      ShowOnlyCurrentRelatedTasks();
      initSavedTextHeight();
      ScrollTreeToCurrentJob();
      $('.TaskTree').removeClass('TaskTree__hidden');
    }, 15);

    $(window).resize(initSavedTextHeight);
  }
});

// Скрытие (схлопывание) всех подзадач - есть в десктопе, в вебе может понадобиться в дальнейшем.
/*function CollapseAllTasks() {
  var jTreeElements = $('.TaskTree').find('[id*="Item_"]');
  jTreeElements.each(function() {
    ChangeItemExpandCollapse($(this).find('.ItemExpandCollapse').get(0));
  });
}*/

// Отображение в раскрытом виде только тех подзадач, которые относятся к текущему заданию.
function ShowOnlyCurrentRelatedTasks() {
  var jTreeElements = $('.TaskTree').find('[id*="Item_"]');
  // Скрытие (схлопывание) подзадач, не содержащих текущее задание.
  jTreeElements.each(function() {
    if (!$(this).find('.ParentForCurrentItemHeader, .CurrentItemHeader').length) {
      var jArrow = $(this).find('.ItemExpandCollapse').get(0);
      ChangeItemExpandCollapse(jArrow);
    }
  });
  // Раскрытие всех потомков текущих элементов.
  var jChildrenOfCurrentElement = $('.CurrentItemHeader').eq(0).parents('div:first').children('div');
  var jExpandCollapseArrow = jChildrenOfCurrentElement.find('.ItemExpandCollapse');
  jExpandCollapseArrow.each(function() {
    if ($(this).hasClass('att_plus.png')) {
      ChangeItemExpandCollapse($(this));
    }
  });
  // Раскрытие всех заданий-потомков родителя текущего элемента.
  var jChildrenOfParentForCurrentElement = $('.ParentForCurrentItemHeader').eq(0).parents('div:first').children('div');
  jChildrenOfParentForCurrentElement.each(function() {
    if ($(this).hasClass('Item_Job')) {
      var jExpandCollapseArrow = $(this).find('.ItemExpandCollapse');
      jExpandCollapseArrow.each(function() {
        if ($(this).hasClass('att_plus.png')) {
          ChangeItemExpandCollapse($(this));
        }
      });
    }
  });
}

// Прокрутка до активного задания.
function ScrollTreeToCurrentJob() {
  var jMainContainer = $('#main_container');

  var jCurrentItem = jMainContainer.find('.CurrentItemHeader').parents('table:first');
  if (!jCurrentItem.length)
    jCurrentItem = jMainContainer.find('.ParentForCurrentItemHeader').parents('table:first');


  if (jCurrentItem.length) {
    var currentItemPos = jCurrentItem.position();
    var jSavedText = jMainContainer.find('.card_task_savedtext_container');
    jSavedText.scrollTop(jSavedText.scrollTop() + currentItemPos.top);
  }
}

//Диалог актуализации срока задачи.
function ShowTaskDeadlineActualizeDialog(onClose) {
  var res = $("<div />", { html: L('TASK_DEADLINE_ACTUALIZE_MSG') }).dialog({
    title: L('CONFIRMATION'),
    resizable: false,
    width: 440,
    modal: true,
    autoOpen: true,
    close: onClose,
    buttons: [
    {
      text: L('ACTUALIZE'),
      click: function () {
        $(this).dialog("close");
        $('.dateField').focus();
      }
    },
    {
      text: L('NOACTUALIZE'),
      click: function () {
        $(this).dialog("close");
        UnbindBeforeUnload();
        DoAction('__POSTBACK_ACTION=StartTask', true);
      }
    },
    {
      text: L('CANCEL'),
      click: function () {
        $(this).dialog("close");
      }
    }
    ]
  });
  InitHoverForButtons(res.next());
}

// Диалог установки прав на вложения
function ShowTaskAttachmentsAssignRightDlg(taskID, userRights, message) {
  //var title = 'What attachments rights assign to task participants?'
  //var msg = 'Some of the task participants do not have minimal necessary attachments rights (to view). Press View, Modify or Full to assign corresponding rights, Ignore if you don\'t want to change any rights and Cancel to abort task start.'
  function ProceedTaskStarting(attachmentsRights) {
    UnbindBeforeUnload();
    CallService("/Task.asmx/SetAttachmentsRights", { TaskID: taskID, Rights: attachmentsRights }, function (res) {
      if (res.Success) {
        DoAction('__POSTBACK_ACTION=StartTask&IgnoreAttachmentsRights=true', true);
      } else {
        ShowTaskAttachmentsAssignRightDlg(taskID, res.Result, res.Error);
      };
    });
  }

  if (userRights == "Empty") {
    DoAction('__POSTBACK_ACTION=StartTask&IgnoreAttachmentsRights=true', true);
    return;
  }

  var mbox = new WA.CMP.dialogs.MessageBox();
  if (userRights == "Full") {
    mbox
     .addButton('view_right_btn', L('VIEWING'), function () { ProceedTaskStarting(ACCESS_RIGHTS.VIEW); })
     .addButton('modify_right_btn', L('MODIFY'), function () { ProceedTaskStarting(ACCESS_RIGHTS.CHANGE); })
     .addButton('full_right_btn', L('FULL'), function () { ProceedTaskStarting(ACCESS_RIGHTS.FULL); })
     .addButton('max_right_btn', L('MAXIMALLY_POSSIBLE_RIGHTS'), function () {
       WA.services.call("/Task.asmx/SetMaximallyPossibleRightsOnAttachments", { TaskID: taskID }).success(function () {
         DoAction('__POSTBACK_ACTION=StartTask&IgnoreAttachmentsRights=true', true);
       });
     })
     .addButton('ignore_button', L('IGNORE'), function () { ProceedTaskStarting(ACCESS_RIGHTS.EMPTY); })
     ._setDefaultButton('view_right_btn');
  }
  if (userRights == "View") {
    mbox
    .addButton('view_right_btn', L('VIEWING'), function () { ProceedTaskStarting(ACCESS_RIGHTS.VIEW); })
    .addButton('ignore_button', L('IGNORE'), function () { ProceedTaskStarting(ACCESS_RIGHTS.EMPTY); })
    ._setDefaultButton('view_right_btn');
  }
  if (userRights == "Change") {
    mbox
      .addButton('view_right_btn', L('VIEWING'), function () { ProceedTaskStarting(ACCESS_RIGHTS.VIEW); })
      .addButton('modify_right_btn', L('MODIFY'), function () { ProceedTaskStarting(ACCESS_RIGHTS.CHANGE); })
      .addButton('max_right_btn', L('MAXIMALLY_POSSIBLE_RIGHTS'), function () {
        WA.services.call("/Task.asmx/SetMaximallyPossibleRightsOnAttachments", { TaskID: taskID }).success(function () {
          DoAction('__POSTBACK_ACTION=StartTask&IgnoreAttachmentsRights=true', true);
        });
      })
      .addButton('ignore_button', L('IGNORE'), function () { ProceedTaskStarting(ACCESS_RIGHTS.EMPTY); })
      ._setDefaultButton('view_right_btn');
  }

  if (userRights == "NoAccess") {
    mbox
    .addButton('ignore_button', L('IGNORE'), function () { ProceedTaskStarting(ACCESS_RIGHTS.EMPTY); })
    ._setDefaultButton('ignore_button');
  }

  mbox.isShowCancelButton = true;
  mbox.isShowOkButton = false;
  var msg = L('ASSING_TASK_ATTACHMENTS_RIGHTS_DLG_MSG');

  if (typeof message != 'undefined') {
    msg = L('WRN_CANNOT_SET_ATTACHMENTS_RIGHTS') + '<br/>' + message;
  }

  mbox.showQuestion(L('ASSING_TASK_ATTACHMENTS_RIGHTS_DLG_CAPTION'), msg, L('ACCESS_RIGHTS'));
}


(function (global) {
  var encryptTaskWithCert = function (id) {
    var encryption = 1;

    var encryptCheckBox = $('#EncryptWithCertCheck');
    var rightType = $('input[id*=RightsType][type=text]');
    setTimeout(function () {
      if (encryption == 1) {
        encryptCheckBox.attr('checked', 'chedked').change();
        //rightType.data('DropDownListInstance').addDropDownListItem(['M', L('MANUAL'), L('MANUAL'), false]).setValue('M').disable();
      } else {
        encryptCheckBox.removeAttr('checked').change();
        //rightType.data('DropDownListInstance').removeDropDownListItem('M').setPrevValue().enable();
      }
    }, 100);
    $('#TaskEncryptionType').val(encryption);
    //SaveInTask();

    //setEncryption(id, encryption, '',
    //  function () {
    //    var button = $(WA.current.toolBar.buttons.EncryptTask.selector);
    //    var rightType = $('input[id*=RightsType][type=text]');
    //    if (encryption == 1) {
    //      button.addClass('selected');
    //      rightType.data('DropDownListInstance').addDropDownListItem(['M', L('MANUAL'), L('MANUAL'), false]).setValue('M').disable();
    //    } else {
    //      button.removeClass('selected');
    //      rightType.data('DropDownListInstance').removeDropDownListItem('M').setValue('A').enable();
    //    }

    //  }, function() {
    //  });
  };

  var setEncryption = function (id, encryption, password, onSuccess, onFail) {
    WA.SRV.call('/Task.asmx/SetEncryption', { TaskID: id, Encryption: encryption, Password: password })
      .success(function (res) {
        HideTopSpinner('task enctypted!');
        if (!!onSuccess) onSuccess();
      })
      .fail(function (error) {
        if (!!onFail) onFail(error);
      });
  };

  global.EncryptTaskWithCert = function (id) {
    return encryptTaskWithCert(id);
  };
})(window);

function EncryptWithCertCheckbox(el) {
  var encryption = $(el).is(':checked') ? 1 : 0;
  var rightType = $('input[id*=RightsType][type=text]');
  var dropDownList = rightType.data('DropDownListInstance');
  if (encryption == 1) {
    dropDownList.addDropDownListItem(['M', L('MANUAL'), L('MANUAL'), false]).setValue('M').disable();
    if (dropDownList.prevValue != 'M') $.cookie('lastAccessType', dropDownList.prevValue);
  } else {
    dropDownList.removeDropDownListItem('M');
    if (!!$.cookie('lastAccessType')) dropDownList.setValue($.cookie('lastAccessType')).enable();
    else dropDownList.setPrevValue().enable();
  }
  $('#TaskEncryptionType').val(encryption);
}

$(function () {
  WA.ready(function () {
    setTimeout(function () {
      if (WA.getLocation() == 'task') {
        var rightType = $('input[id*=RightsType][type=text]');
        if ($('#TaskEncryptionType').val() == '1') {
          if (rightType.length) rightType.data('DropDownListInstance').addDropDownListItem(['M', L('MANUAL'), L('MANUAL'), false]).setValue('M').disable();
          $('#EncryptWithCertCheck').attr('checked', true);
        } else {
          if (rightType.length && (WA.Task.ID == WA.Task.MainTaskID)) rightType.data('DropDownListInstance').removeDropDownListItem('M').setPrevValue().enable();
          $('#EncryptWithCertCheck').removeAttr('checked');
        }
      }
    }, 100);
  });
})

/**
 * Добавляет ссылку на объект во вложения.
 * @param {Link} link Ссылка на объект.
 * @since 5.1.0.1522
 */
function AddAttachment(link) {
  if (!!link) {
    var att = ListRequisite('ctl00_MainContent_Attachments_AttachmentsList');
    var linkModel = link.toLinkModel();
    // Проверяем если уже такая ссылка.
    if (att.CheckObject(linkModel)) {
      // Если нет, то добавляем.
      att.AddObject(linkModel);
      att.UpdateList();
    }
  }
};